import { flow } from 'lodash/fp';
import { formatMoney } from 'helpers/i18n';

const CONVERSION_MINOR = 100;

export const getPrice = (amountMinorUnits) =>
  amountMinorUnits ? amountMinorUnits / CONVERSION_MINOR : 0;

export const convertToMinorUnits = (price) => price * CONVERSION_MINOR;

export const getAdPrice = (price) => {
  if (!price) {
    return;
  }

  return price.amountMinorUnits / CONVERSION_MINOR;
};

export const getFormattedAdPrice = flow(getAdPrice, formatMoney);

export const getMonthlyPrice = (monthlyPrice) => {
  if (!monthlyPrice) {
    return;
  }

  return monthlyPrice.amountMinorUnits / CONVERSION_MINOR;
};

export const getFormattedMonthlyPrice = flow(
  getMonthlyPrice,
  (monthlyPrice) => Math.round(monthlyPrice),
  formatMoney,
);

export const convertToMajorUnits = (value) => {
  if (!value) {
    return;
  }

  return value.amountMinorUnits / CONVERSION_MINOR;
};
